import { useState, useEffect } from 'react';
import { wall0, wall1, wall2, wall3, wall4, wall5, wall6, wall7, wall8, wall9, wall10 } from './assets/images';
import { floor0, floor1, floor2, floor3, floor4, floor5, floor6, floor7, floor8, floor9 } from './assets/images';
import { useBottomImageIndex, useTopImageIndex } from './states/hooks';

export const BACKGROUND_IMAGES = [wall0, wall1, wall2, wall3, wall4, wall5, wall6, wall7, wall8, wall9, wall10];
export const FLOOR_IMAGES = [floor0, floor1, floor2, floor3, floor4, floor5, floor6, floor7, floor8, floor9];

interface PersonalMeetingCornerState {
    isTopImageLoaded: boolean;
    setIsTopImageLoaded: (loaded: boolean) => void;
    isBottomImageLoaded: boolean;
    setIsBottomImageLoaded: (loaded: boolean) => void;
}

export const usePersonalMeetingCornerState = (): PersonalMeetingCornerState => {
    const [topImageIndex] = useTopImageIndex();
    const [bottomImageIndex] = useBottomImageIndex();
    const [isTopImageLoaded, setIsTopImageLoaded] = useState(true);
    const [isBottomImageLoaded, setIsBottomImageLoaded] = useState(true);

    useEffect(() => {
        const preload = (src: string) => {
            const img = document.createElement('img');
            img.src = src;
        };

        preload(BACKGROUND_IMAGES[(topImageIndex + 1) % BACKGROUND_IMAGES.length]);
        preload(BACKGROUND_IMAGES[(topImageIndex - 1 + BACKGROUND_IMAGES.length) % BACKGROUND_IMAGES.length]);
        preload(FLOOR_IMAGES[(bottomImageIndex + 1) % FLOOR_IMAGES.length]);
        preload(FLOOR_IMAGES[(bottomImageIndex - 1 + FLOOR_IMAGES.length) % FLOOR_IMAGES.length]);
    }, [topImageIndex, bottomImageIndex]);

    return {
        isTopImageLoaded,
        setIsTopImageLoaded,
        isBottomImageLoaded,
        setIsBottomImageLoaded
    };
};
